angular.module('dnecom')
    .service('ProductAttributesUtils', ["$http", function ($http) {
        this.getDefaultColors = function () {
            return {
                'FFB81C': 'Athletic Gold',
                '000000': 'Black',
                '0254A2': 'Blue',
                '7B4931': 'Brown',
                '9D2235': 'Cardinal',
                '54585A': 'Dark Grey',
                '154734': 'Forest',
                '8E9089': 'Grey',
                'FF3EB3': 'Hot Pink',
                '006747': 'Kelly Green',
                'F9E547': 'Lemon',
                '9ADBE8': 'Light Blue',
                'C7C9C7': 'Light Grey',
                'CBA3D8': 'Light Purple',
                '8EDD65': 'Lime',
                'C5299B': 'Magenta',
                '7E2D40': 'Maroon',
                '13294B': 'Navy',
                'B58500': 'Old Gold',
                '827A04': 'Olive',
                'FF6A13': 'Orange',
                'E53C2E': 'Orange Red',
                'FABBCB': 'Pink',
                '3D0182': 'Purple',
                'CB333B': 'Red',
                '003087': 'Royal',
                'D9C89E': 'Tan',
                '3EB1C8': 'Turquoise',
                'f6f6f6': 'White',
                '00843D': 'Green',
                'FDDA24': 'Yellow'
            };
        };

        this.addValue = function (storeId, productId, attributeId, value, callback, errorCallback) {
            if (!value) {
                errorCallback();
                return;
            }

            $http
                .post(
                    Routing.generate('products_attributes_values_add', {
                        id: storeId,
                        productId: productId,
                        attributeId: attributeId
                    }),
                    { value: value.value, name: value.name }
                )
                .then(function (response) {
                    if (response.data.success) {
                        if (callback) {
                            callback(response);
                        }
                    } else if (errorCallback) {
                        errorCallback(response);
                    }
                }, function (response) {
                    if (errorCallback) {
                        errorCallback(response);
                    }
                });
        };

        this.removeValue = function (storeId, productId, attributeId, value, callback, errorCallback) {
            if (!value) {
                errorCallback();
                return;
            }

            $http
                .delete(
                    Routing.generate('products_attributes_values_delete', {
                        id: storeId,
                        productId: productId,
                        attributeId: attributeId,
                        valueId: value.id
                    })
                )
                .then(function (response) {
                    if (response.data.success) {
                        if (callback) {
                            callback(value);
                        }
                    } else if (errorCallback) {
                        errorCallback(value);
                    }
                }, function () {
                    if (errorCallback) {
                        errorCallback(value);
                    }
                });
        };

        this.filterColors = function (recentlyAddedColors, predefinedColors) {
            var result = {};

            for (var key in recentlyAddedColors) {
                if (recentlyAddedColors.hasOwnProperty(key) && !predefinedColors.hasOwnProperty(key)) {
                        result[key] = recentlyAddedColors[key];
                }

                if (Object.keys(result).length == 15) {
                    break;
                }
            }

            return result;
        };

        return this;
    }]);
